/**
 * Fleet analytics helpers for habits — the small PURE bits behind the typed `useTrack()`
 * emits (taxonomy: @owlcat/app-shell analytics-events.ts). Props are ids / enums / counts only.
 */
import type { Track } from "@owlcat/app-shell";
import type { Channels, Person } from "@/lib/people";

/** the habit's owner as the taxonomy sees them: an account member = self, a managed child = child */
export function personKind(people: Pick<Person, "id" | "isMember">[], personId: string): "self" | "child" {
  return people.find((p) => p.id === personId)?.isMember ? "self" : "child";
}

/** the channel a reminder will actually reach (prefs-aware), else the preferred / first set-up one */
export function reminderChannel(channels: Channels | null | undefined): "telegram" | "email" | null {
  if (!channels) return null;
  return channels.notifyChannel ?? channels.preferred ?? (channels.telegram ? "telegram" : channels.email ? "email" : null);
}

const SIGNED_IN_KEY = "owlcat.habits.signed_in";

/** `signed_in` ONCE per browser session per identity (sessionStorage one-shot; storage may throw → emit anyway). */
export function signedInOnce(identityId: string | null | undefined, track: Track): boolean {
  if (!identityId) return false;
  try {
    if (sessionStorage.getItem(SIGNED_IN_KEY) === identityId) return false;
    sessionStorage.setItem(SIGNED_IN_KEY, identityId);
  } catch {
    /* private mode / blocked storage: still count the session */
  }
  track("signed_in", { provider: "sso", method: "sso" });
  return true;
}
